// extracted by mini-css-extract-plugin
export default {"container":"menu_container__0K3XQ","menu":"menu_menu__Dg1Ie","comp":"menu_comp__PfRW6","info":"menu_info__qUEpX"};